module.exports = __webpack_public_path__ + "static/media/quar2.ea1ee0d0.png";